<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <wc-data-box
            title='All Invoices'
            :titleIcon='$store.state.icons.dataBox.invoices.icon'
            titleIconColor='grey'
            :showAdd='!client.on_hold && !client.archived'
            @add='showDialog = true'
            showArchived
            :showArchivedStatus='showArchived'
            @toggleShowArchived='showArchived = !showArchived'
          >
            <template v-slot:toolbarButtons>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
            </template>
            <v-data-table
              :loading='isLoading'
              dense
              :search='search'
              :items='filteredInvoices'
              :headers='headers'
              @click:row='openInvoice'
              :items-per-page='20'
              sort-by='invoice_date'
              sort-desc
            >
              <template v-slot:item.invoice_date='{ item }'>
                {{ item.invoice_date | shortDate }}
              </template>
              <template v-slot:item.date_sent='{ item }'>
                {{ item.date_sent | shortDate }}
              </template>
              <template v-slot:item.number='{ item }'>
                {{ item.number }}
                <v-icon class='ml-2' v-if='item.archived' color='error'>mdi-archive</v-icon>
              </template>
              <template v-slot:item.status='{ item }'>
                  <status-chip :invoice='item' small :status="item.status"></status-chip>
              </template>
              <template v-slot:item.original_amount='{ item }'>
                {{ item.original_amount | dec }}
              </template>
              <template v-slot:item.amount_os='{ item }'>
                {{ item.amount_os | dec }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <new-invoice-dialog
      :showDialog='showDialog'
      :billTo='client'
      @cancel='showDialog = false'
    ></new-invoice-dialog>
  </div>
</template>

<script>
import StatusChip from '@/modules/accounting/components/invoice/StatusChip'
import clientsAPI from '@/modules/clients/api/clients'
import NewInvoiceDialog from '@/modules/accounting/components/NewInvoiceDialog'

export default {
  name: 'client-invoices',
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    search: "",
    invoices: [],
    isLoading: true,
    showDialog: false,
    showArchived: false,
    headers: [
      { text: 'Invoice Date', value: 'invoice_date', width: '150' },
      { text: 'Number', value: 'number', width: '190', align: 'start' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Division', value: 'division_display', align: 'center' },
      { text: 'Original Amt', value: 'original_amount', width:'150', align: 'end' },
      { text: 'Amount OS', value: 'amount_os', width:'150', align: 'end' }
    ],
  }),
  created () {
    this.getInvoices ()
  },
  computed: {
    filteredInvoices () {
      if (this.showArchived) {
        return this.invoices
      }
      return this.invoices.filter(i => i.archived === false)
    }
  },
  methods: {
    openInvoice (item) {
      this.$router.push({ name: 'InvoiceOverview', params: { id: item.id } })
    },
    async getInvoices () {
        this.isLoading = true
        this.invoices = await clientsAPI.getClientInvoices(this.client.id)
        this.isLoading = false
    }
  },
  components: {
    'status-chip': StatusChip,
    'new-invoice-dialog': NewInvoiceDialog
  }
}
</script>
